var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-tabs",
        {
          attrs: { id: "persontabs" },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Biographical" } },
            [
              _c(
                "b-card",
                { staticStyle: { border: "none" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                "label-for": "b_first_name",
                                horizontal: false
                              }
                            },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("\n                  First Name "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-name": "person.b_first_name",
                                  "data-vv-as": "First Name",
                                  size: "lg",
                                  id: "b_first_name"
                                },
                                model: {
                                  value: _vm.person.b_first_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_first_name", $$v)
                                  },
                                  expression: "person.b_first_name"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "person.b_first_name"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('person.b_first_name')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "person.b_first_name"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                "label-for": "b_last_name",
                                horizontal: false
                              }
                            },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("\n                  Last Name "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  required: "",
                                  size: "lg",
                                  "data-vv-name": "person.b_last_name",
                                  "data-vv-as": "Last Name",
                                  id: "b_last_name"
                                },
                                model: {
                                  value: _vm.person.b_last_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_last_name", $$v)
                                  },
                                  expression: "person.b_last_name"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "person.b_last_name"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('person.b_last_name')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "person.b_last_name"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "nicknamelabel",
                                label: "Nickname or Other Identifier",
                                "label-for": "b_nickname",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  required: "",
                                  size: "lg",
                                  "data-vv-name": "person.b_nickname",
                                  "data-vv-as": "Nickname",
                                  id: "b_nickname"
                                },
                                model: {
                                  value: _vm.person.b_nickname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_nickname", $$v)
                                  },
                                  expression: "person.b_nickname"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "person.b_nickname"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('person.b_nickname')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "person.b_nickname"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Birthdate",
                                "label-for": "b_birthdate",
                                horizontal: false
                              }
                            },
                            [
                              _c("datepicker", {
                                attrs: {
                                  "input-class": "form-control-lg",
                                  "initial-view": "year",
                                  id: "b_birthdate",
                                  placeholder: "Select Date",
                                  format: this.$dateFormatter,
                                  "disabled-dates": { from: new Date() },
                                  "clear-button": ""
                                },
                                model: {
                                  value: _vm.person.b_birthdate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_birthdate", $$v)
                                  },
                                  expression: "person.b_birthdate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "nicknamelabel",
                                label: "Approximate Age",
                                "label-for": "b_approximate_age",
                                horizontal: false
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "-20px",
                                    "font-style": "italic"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Please enter a numerical value for the person's actual or approximate age, in years, if Birthdate is left blank."
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  type: "number",
                                  step: "1",
                                  formatter: _vm.formatter,
                                  size: "lg",
                                  "data-vv-name": "person.b_approximate_age",
                                  "data-vv-as": "Approximate Age",
                                  id: "b_approximate_age"
                                },
                                model: {
                                  value: _vm.person.b_approximate_age,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "b_approximate_age",
                                      $$v
                                    )
                                  },
                                  expression: "person.b_approximate_age"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "person.b_approximate_age"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('person.b_approximate_age')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "person.b_approximate_age"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Race",
                                "label-for": "b_race",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.race_options,
                                  id: "b_race",
                                  "data-vid": "person.b_race"
                                },
                                model: {
                                  value: _vm.person.b_race,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_race", $$v)
                                  },
                                  expression: "person.b_race"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_race === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for": "b_race_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.person.b_race === "Other"
                                            ? "required"
                                            : "",
                                        expression:
                                          "person.b_race === 'Other' ? 'required' : '' "
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-name": "person.b_race_otherText",
                                      "data-vv-as": "Other Race",
                                      size: "lg",
                                      id: "b_race_otherText"
                                    },
                                    model: {
                                      value: _vm.person.b_race_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "b_race_otherText",
                                          $$v
                                        )
                                      },
                                      expression: "person.b_race_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "person.b_race_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('person.b_race_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "person.b_race_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Ethnicity",
                                "label-for": "b_ethnicity",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.ethnicity_options,
                                  id: "b_ethnicity",
                                  "data-vid": "person.b_ethnicity"
                                },
                                model: {
                                  value: _vm.person.b_ethnicity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_ethnicity", $$v)
                                  },
                                  expression: "person.b_ethnicity"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_ethnicity === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for": "b_ethnicity_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.person.b_ethnicity === "Other"
                                            ? "required"
                                            : "",
                                        expression:
                                          "person.b_ethnicity === 'Other' ? 'required' : '' "
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-name":
                                        "person.b_ethnicity_otherText",
                                      "data-vv-as": "Other Ethnicity",
                                      size: "lg",
                                      id: "b_ethnicity_otherText"
                                    },
                                    model: {
                                      value: _vm.person.b_ethnicity_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "b_ethnicity_otherText",
                                          $$v
                                        )
                                      },
                                      expression: "person.b_ethnicity_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "person.b_ethnicity_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('person.b_ethnicity_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "person.b_ethnicity_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Gender Assigned at Birth",
                                "label-for": "b_gender",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.gender_options,
                                  id: "b_gender"
                                },
                                model: {
                                  value: _vm.person.b_gender,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_gender", $$v)
                                  },
                                  expression: "person.b_gender"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_gender === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for": "b_gender_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.person.b_gender === "Other"
                                            ? "required"
                                            : "",
                                        expression:
                                          "person.b_gender === 'Other' ? 'required' : '' "
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-name":
                                        "person.b_gender_otherText",
                                      "data-vv-as": "Other Gender",
                                      size: "lg",
                                      id: "b_gender_otherText"
                                    },
                                    model: {
                                      value: _vm.person.b_gender_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "b_gender_otherText",
                                          $$v
                                        )
                                      },
                                      expression: "person.b_gender_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "person.b_gender_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('person.b_gender_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "person.b_gender_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Current Gender Identity",
                                "label-for": "b_gender_identity",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.gender_identity,
                                  id: "b_gender"
                                },
                                model: {
                                  value: _vm.person.b_gender_identity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "b_gender_identity",
                                      $$v
                                    )
                                  },
                                  expression: "person.b_gender_identity"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_gender_identity === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for": "b_gender_identity_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.person.b_gender === "Other"
                                            ? "required"
                                            : "",
                                        expression:
                                          "person.b_gender === 'Other' ? 'required' : '' "
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-name":
                                        "person.b_gender_identity_otherText",
                                      "data-vv-as": "Other Gender Identity",
                                      size: "lg",
                                      id: "b_gender_identity_otherText"
                                    },
                                    model: {
                                      value:
                                        _vm.person.b_gender_identity_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "b_gender_identity_otherText",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "person.b_gender_identity_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "person.b_gender_identity_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('person.b_gender_identity_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "person.b_gender_identity_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Sexual Orientation",
                                "label-for": "b_orientation",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.orientation_options,
                                  id: "b_orientation"
                                },
                                model: {
                                  value: _vm.person.b_orientation,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_orientation", $$v)
                                  },
                                  expression: "person.b_orientation"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_orientation === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for": "b_orientation_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.person.b_orientation === "Other"
                                            ? "required"
                                            : "",
                                        expression:
                                          "person.b_orientation === 'Other' ? 'required' : '' "
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-name":
                                        "person.b_orientation_otherText",
                                      "data-vv-as": "Other Orientation",
                                      size: "lg",
                                      id: "b_orientation_otherText"
                                    },
                                    model: {
                                      value: _vm.person.b_orientation_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "b_orientation_otherText",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "person.b_orientation_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "person.b_orientation_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('person.b_orientation_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "person.b_orientation_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Education Level",
                                "label-for": "p_grade_level",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.gradeLevelOptions,
                                  id: "p_grade_level"
                                },
                                model: {
                                  value: _vm.person.p_grade_level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_grade_level", $$v)
                                  },
                                  expression: "person.p_grade_level"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Education Type",
                                "label-for": "p_education_type",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.educationTypes,
                                  id: "p_education_type"
                                },
                                model: {
                                  value: _vm.person.p_education_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_education_type",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_education_type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Disability",
                                "label-for": "b_disability",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.disabilityOptions,
                                  id: "b_disability"
                                },
                                model: {
                                  value: _vm.person.b_disability,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "b_disability", $$v)
                                  },
                                  expression: "person.b_disability"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.b_disability === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    label: "Disability Description",
                                    "label-for": "b_disability_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _vm.person.b_disability === "Other"
                                    ? _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          size: "lg",
                                          "data-vv-name": "Other",
                                          "data-vv-as": "Other"
                                        },
                                        model: {
                                          value:
                                            _vm.person.b_disability_otherText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.person,
                                              "b_disability_otherText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "person.b_disability_otherText"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "b_disability_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('b_disability_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "b_disability_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Immigration Status",
                                "label-for": "b_immigration_category",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.immigration_options,
                                  id: "b_immigration_category"
                                },
                                model: {
                                  value: _vm.person.b_immigration_category,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "b_immigration_category",
                                      $$v
                                    )
                                  },
                                  expression: "person.b_immigration_category"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "Victim Information" } },
            [
              _vm._l(_vm.personVictimInfo, function(info, index) {
                return _c("PersonVictimInfoForm", {
                  key: index,
                  attrs: {
                    victimInfo: info,
                    stateName: _vm.stateName,
                    compiledVictimInfo: _vm.compiledVictimInfo,
                    isCareCoordinator: _vm.isCareCoordinator,
                    isOrgManager: _vm.isOrgManager,
                    getNonUSCountries: _vm.getNonUSCountries
                  }
                })
              }),
              _vm._v(" "),
              _vm._l(_vm.newVictimInfo, function(info, index) {
                return _c("PersonVictimInfoForm", {
                  key: "new-" + index,
                  attrs: {
                    victimInfo: info,
                    stateName: _vm.stateName,
                    compiledVictimInfo: _vm.compiledVictimInfo,
                    isCareCoordinator: _vm.isCareCoordinator,
                    isOrgManager: _vm.isOrgManager,
                    getNonUSCountries: _vm.getNonUSCountries
                  }
                })
              }),
              _vm._v(" "),
              _vm.isAllowedToAddTypeOfTrafficking
                ? _c(
                    "div",
                    { staticClass: "card noBoxShadow flexRowEnd" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.addAnotherTypeOfTrafficking }
                        },
                        [
                          _vm._v(
                            "Add Another Type of Trafficking & Exploitation"
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.person.b_confirmed
            ? _c(
                "b-tab",
                { attrs: { title: "Services" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "width100" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    label: "Program Entry Date",
                                    "label-for": "s_program_entry_date",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("datepicker", {
                                    ref: "s_program_entry_dateRef",
                                    attrs: {
                                      "input-class": "form-control-lg",
                                      "initial-view": "year",
                                      id: "s_program_entry_date",
                                      placeholder: "Select Date",
                                      format: this.$dateFormatter,
                                      "disabled-dates": { from: new Date() },
                                      "clear-button": ""
                                    },
                                    model: {
                                      value: _vm.person.s_program_entry_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "s_program_entry_date",
                                          $$v
                                        )
                                      },
                                      expression: "person.s_program_entry_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    label: "Program Discharge Date",
                                    "label-for": "s_program_discharge_date",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("datepicker", {
                                    attrs: {
                                      "input-class": "form-control-lg",
                                      "initial-view": "year",
                                      id: "s_program_discharge_date",
                                      placeholder: "Select Date",
                                      format: this.$dateFormatter,
                                      "disabled-dates": {
                                        to: new Date(
                                          _vm.person.s_program_entry_date
                                        ),
                                        from: new Date()
                                      },
                                      max: new Date(),
                                      "clear-button": ""
                                    },
                                    model: {
                                      value:
                                        _vm.person.s_program_discharge_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "s_program_discharge_date",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "person.s_program_discharge_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.person.s_program_discharge_date
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Discharge Reason",
                                        "label-for": "s_discharge_reason",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.discharge_options,
                                          id: "s_discharge_reason"
                                        },
                                        model: {
                                          value: _vm.person.s_discharge_reason,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.person,
                                              "s_discharge_reason",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "person.s_discharge_reason"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.person.s_discharge_reason === "Other"
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Discharge Description",
                                        "label-for":
                                          "s_discharge_reason_otherText",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _vm.person.s_discharge_reason === "Other"
                                        ? _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              size: "lg",
                                              "data-vv-name": "Other",
                                              "data-vv-as": "Other"
                                            },
                                            model: {
                                              value:
                                                _vm.person
                                                  .s_discharge_reason_otherText,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.person,
                                                  "s_discharge_reason_otherText",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "person.s_discharge_reason_otherText"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.inputValidationErrors.has(
                                                "s_discharge_reason_otherText"
                                              ),
                                              expression:
                                                "inputValidationErrors.has('s_discharge_reason_otherText')"
                                            }
                                          ],
                                          staticClass: "text-info"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.inputValidationErrors.first(
                                                "s_discharge_reason_otherText"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    stacked: "",
                                    "label-size": "lg",
                                    "label-class": "font-weight-bold",
                                    label:
                                      "Services Provided During Program Enrollment"
                                  }
                                },
                                [
                                  _c("info-icon", {
                                    staticStyle: {
                                      position: "relative",
                                      top: "-37px",
                                      "margin-left": "444px",
                                      cursor: "pointer"
                                    },
                                    attrs: { id: "tooltip-target-2" },
                                    on: { click: _vm.handleServicesModal }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "margin-top": "-20px",
                                        "font-style": "italic"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Select all services that were provided to the victim during the program enrollment period."
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-alert",
                                    {
                                      ref: "servicesWithNoEntryDateWarnRef",
                                      attrs: {
                                        show: !_vm.person.s_program_entry_date,
                                        variant: "warning"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Please enter a Program Entry Date."
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-checkbox-group", {
                                    staticClass: "checkboxGroup",
                                    attrs: {
                                      disabled: !_vm.person
                                        .s_program_entry_date,
                                      options: _vm.services_provided,
                                      "value-field": "value",
                                      "text-field": "text",
                                      stacked: ""
                                    },
                                    model: {
                                      value: _vm.selectedServices,
                                      callback: function($$v) {
                                        _vm.selectedServices = $$v
                                      },
                                      expression: "selectedServices"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "Supplemental Information" } },
            [
              _c(
                "b-card",
                { staticClass: "width100" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "PID#",
                                "label-for": "p_pid",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "lg", type: "text" },
                                model: {
                                  value: _vm.person.p_pid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_pid", $$v)
                                  },
                                  expression: "person.p_pid"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Presenting Offense",
                                "label-for": "p_presenting_offense",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.presentingOffenseOptions,
                                  id: "p_presenting_offense"
                                },
                                model: {
                                  value: _vm.person.p_presenting_offense,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_presenting_offense",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_presenting_offense"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.p_presenting_offense === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    "label-for":
                                      "p_presenting_offense_otherText",
                                    label: "Presenting Offense Description",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      size: "lg",
                                      "data-vv-name": "Other",
                                      "data-vv-as": "Other"
                                    },
                                    model: {
                                      value:
                                        _vm.person
                                          .p_presenting_offense_otherText,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.person,
                                          "p_presenting_offense_otherText",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "person.p_presenting_offense_otherText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "p_presenting_offense_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('p_presenting_offense_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "p_presenting_offense_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Street Name/Alias",
                                "label-for": "p_street_name",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "lg", id: "p_street_name" },
                                model: {
                                  value: _vm.person.p_street_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_street_name", $$v)
                                  },
                                  expression: "person.p_street_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Last Home Location Description",
                                "label-for": "p_last_home_location",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "lg",
                                  id: "p_last_home_location"
                                },
                                model: {
                                  value: _vm.person.p_last_home_location,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_last_home_location",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_last_home_location"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Street",
                                "label-for": "p_last_home_location_street",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "lg",
                                  id: "p_last_home_location_street"
                                },
                                model: {
                                  value: _vm.person.p_last_home_location_street,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_last_home_location_street",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "person.p_last_home_location_street"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "City",
                                "label-for": "p_last_home_location_city",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "lg",
                                  id: "p_last_home_location_city"
                                },
                                model: {
                                  value: _vm.person.p_last_home_location_city,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_last_home_location_city",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_last_home_location_city"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "State",
                                "label-for": "p_last_home_location_state",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.mailingStateOptions(),
                                  id: "p_last_home_location_state"
                                },
                                model: {
                                  value: _vm.person.p_last_home_location_state,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_last_home_location_state",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "person.p_last_home_location_state"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Zip",
                                "label-for": "p_last_home_location_zip",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "lg",
                                  id: "p_last_home_location_zip"
                                },
                                model: {
                                  value: _vm.person.p_last_home_location_zip,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_last_home_location_zip",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_last_home_location_zip"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Country of Origin",
                                "label-for": "p_country_of_origin",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.countries,
                                  id: "p_country_of_origin"
                                },
                                model: {
                                  value: _vm.person.p_country_of_origin,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.person,
                                      "p_country_of_origin",
                                      $$v
                                    )
                                  },
                                  expression: "person.p_country_of_origin"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Poverty Line",
                                "label-for": "p_poverty_line",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.povertyOptions,
                                  id: "p_poverty_line"
                                },
                                model: {
                                  value: _vm.person.p_poverty_line,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_poverty_line", $$v)
                                  },
                                  expression: "person.p_poverty_line"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label:
                                  "Is the youth performing labor or services (not including sex) induced by force, fraud, or coercion?",
                                "label-for": "p_forcedlabor",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.yesNoUnknownOptions,
                                  id: "p_forcedlabor"
                                },
                                model: {
                                  value: _vm.person.p_forcedlabor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_forcedlabor", $$v)
                                  },
                                  expression: "person.p_forcedlabor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Guardian",
                                "label-for": "p_guardian",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.guardianOptions,
                                  id: "p_guardian"
                                },
                                model: {
                                  value: _vm.person.p_guardian,
                                  callback: function($$v) {
                                    _vm.$set(_vm.person, "p_guardian", $$v)
                                  },
                                  expression: "person.p_guardian"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.person.p_guardian === "Other"
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    label: "Guardian Description",
                                    "label-for": "p_guardian_otherText",
                                    horizontal: false
                                  }
                                },
                                [
                                  _vm.person.p_guardian === "Other"
                                    ? _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          size: "lg",
                                          "data-vv-name": "Other",
                                          "data-vv-as": "Other"
                                        },
                                        model: {
                                          value:
                                            _vm.person.p_guardian_otherText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.person,
                                              "p_guardian_otherText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "person.p_guardian_otherText"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.inputValidationErrors.has(
                                            "p_guardian_otherText"
                                          ),
                                          expression:
                                            "inputValidationErrors.has('p_guardian_otherText')"
                                        }
                                      ],
                                      staticClass: "text-info"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.inputValidationErrors.first(
                                            "p_guardian_otherText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "pb-2 pl-1",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                flush: ""
                              }
                            },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_le_called"
                                  },
                                  model: {
                                    value: _vm.person.p_le_called,
                                    callback: function($$v) {
                                      _vm.$set(_vm.person, "p_le_called", $$v)
                                    },
                                    expression: "person.p_le_called"
                                  }
                                },
                                [_vm._v("LE Called?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_le_called === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "LE Call Date",
                                          "label-for": "p_le_call_date",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("datepicker", {
                                          attrs: {
                                            "input-class": "form-control-lg",
                                            "initial-view": "year",
                                            id: "p_le_call_date",
                                            placeholder: "Select Date",
                                            format: this.$dateFormatter,
                                            "disabled-dates": {
                                              from: new Date()
                                            }
                                          },
                                          model: {
                                            value: _vm.person.p_le_call_date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_le_call_date",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_le_call_date"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          label: "LE Agency",
                                          "label-class": "addpersonlabel",
                                          "label-for": "p_le_agency"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            size: "lg",
                                            options: _vm.getLEOptions,
                                            id: "p_le_agency"
                                          },
                                          model: {
                                            value: _vm.person.p_le_agency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_le_agency",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_le_agency"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.person.p_le_agency === "Other"
                                      ? _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "addpersonlabel",
                                              label: "Agency Name",
                                              "label-for":
                                                "p_le_agency_otherText",
                                              horizontal: false
                                            }
                                          },
                                          [
                                            _vm.person.p_le_agency === "Other"
                                              ? _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    size: "lg",
                                                    "data-vv-name": "Other",
                                                    "data-vv-as": "Other"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.person
                                                        .p_le_agency_otherText,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.person,
                                                        "p_le_agency_otherText",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "person.p_le_agency_otherText"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.inputValidationErrors.has(
                                                      "p_le_agency_otherText"
                                                    ),
                                                    expression:
                                                      "inputValidationErrors.has('p_le_agency_otherText')"
                                                  }
                                                ],
                                                staticClass: "text-info"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.inputValidationErrors.first(
                                                      "p_le_agency_otherText"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_perpetrator_known"
                                  },
                                  model: {
                                    value: _vm.person.p_perpetrator_known,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_perpetrator_known",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_perpetrator_known"
                                  }
                                },
                                [_vm._v("Was the Alleged Perpetrator Known?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_perpetrator_known === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          label: "Name of Alleged Perpetrator",
                                          "label-class": "addpersonlabel",
                                          "label-for": "p_perpetrator_name"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            name: "p_perpetrator_name",
                                            id: "p_perpetrator_name"
                                          },
                                          model: {
                                            value:
                                              _vm.person.p_perpetrator_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_perpetrator_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_perpetrator_name"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_cps_called"
                                  },
                                  model: {
                                    value: _vm.person.p_cps_called,
                                    callback: function($$v) {
                                      _vm.$set(_vm.person, "p_cps_called", $$v)
                                    },
                                    expression: "person.p_cps_called"
                                  }
                                },
                                [_vm._v("CPS Called?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_cps_called === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "CPS Call Date",
                                          "label-for": "b_cps_call_date",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("datepicker", {
                                          attrs: {
                                            "input-class": "form-control-lg",
                                            "initial-view": "year",
                                            id: "b_cps_call_date",
                                            placeholder: "Select Date",
                                            format: this.$dateFormatter,
                                            "disabled-dates": {
                                              from: new Date()
                                            }
                                          },
                                          model: {
                                            value: _vm.person.p_cps_call_date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_cps_call_date",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_cps_call_date"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "CPS ID Number",
                                          "label-for": "p_cps_id_number",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            id: "p_cps_id_number"
                                          },
                                          model: {
                                            value: _vm.person.p_cps_id_number,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_cps_id_number",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_cps_id_number"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "CPS Reference Number",
                                          "label-for": "p_cps_reference_number",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            id: "p_cps_reference_number"
                                          },
                                          model: {
                                            value:
                                              _vm.person.p_cps_reference_number,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_cps_reference_number",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_cps_reference_number"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_cac_interview"
                                  },
                                  model: {
                                    value: _vm.person.p_cac_interview,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_cac_interview",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_cac_interview"
                                  }
                                },
                                [_vm._v("CAC Interview?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_cac_interview === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "Interview Date",
                                          "label-for": "p_cac_call_date",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("datepicker", {
                                          attrs: {
                                            "input-class": "form-control-lg",
                                            "initial-view": "year",
                                            id: "p_cac_call_date",
                                            placeholder: "Select Date",
                                            format: this.$dateFormatter,
                                            "disabled-dates": {
                                              from: new Date()
                                            }
                                          },
                                          model: {
                                            value: _vm.person.p_cac_call_date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_cac_call_date",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_cac_call_date"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          label: "CAC Agency",
                                          "label-class": "addpersonlabel",
                                          "label-for": "p_cac_agency"
                                        }
                                      },
                                      [
                                        _c("v-select", {
                                          staticStyle: { width: "600px" },
                                          attrs: {
                                            id: "p_cac_agency",
                                            options: _vm.getCacOptions,
                                            placeholder: "Search"
                                          },
                                          model: {
                                            value: _vm.person.p_cac_agency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_cac_agency",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_cac_agency"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "pb-2 pl-1",
                                        attrs: { flush: "" }
                                      },
                                      [
                                        _c(
                                          "p-check",
                                          {
                                            staticClass:
                                              "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                            attrs: {
                                              large: "",
                                              color: "success",
                                              "true-value": "Yes",
                                              "false-value": "",
                                              name: "p_outcry"
                                            },
                                            model: {
                                              value: _vm.person.p_outcry,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.person,
                                                  "p_outcry",
                                                  $$v
                                                )
                                              },
                                              expression: "person.p_outcry"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Outcry Made?\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_csey_advocate_called"
                                  },
                                  model: {
                                    value: _vm.person.p_csey_advocate_called,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_csey_advocate_called",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_csey_advocate_called"
                                  }
                                },
                                [_vm._v("CSEY Advocate Called?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_csey_advocate_called === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "CSEY Advocate Call Date",
                                          "label-for":
                                            "p_csey_advocate_called_date",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("datepicker", {
                                          attrs: {
                                            "input-class": "form-control-lg",
                                            "initial-view": "year",
                                            id: "p_csey_advocate_called_date",
                                            placeholder: "Select Date",
                                            format: this.$dateFormatter,
                                            "disabled-dates": {
                                              from: new Date()
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.person
                                                .p_csey_advocate_called_date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_csey_advocate_called_date",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_csey_advocate_called_date"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "CSEY Agency/Contact ",
                                          "label-for":
                                            "p_csey_advocate_called_contact",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            id:
                                              "p_csey_advocate_called_contact",
                                            name:
                                              "p_csey_advocate_called_contact"
                                          },
                                          model: {
                                            value:
                                              _vm.person
                                                .p_csey_advocate_called_contact,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_csey_advocate_called_contact",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_csey_advocate_called_contact"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_gang_affiliation"
                                  },
                                  model: {
                                    value: _vm.person.p_gang_affiliation,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_gang_affiliation",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_gang_affiliation"
                                  }
                                },
                                [_vm._v("Gang Affiliation?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_gang_affiliation === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "Gang Name ",
                                          "label-for": "p_gang_description",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            id: "p_gang_description",
                                            name: ""
                                          },
                                          model: {
                                            value:
                                              _vm.person.p_gang_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_gang_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_gang_description"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          label: "Location by County / Parish",
                                          "label-class": "addpersonlabel",
                                          "label-for": "p_gang_county"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "p_gang_county",
                                            label: "value",
                                            options: _vm.countyOrParishOptions,
                                            placeholder: "Search"
                                          },
                                          model: {
                                            value: _vm.person.p_gang_county,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_gang_county",
                                                $$v
                                              )
                                            },
                                            expression: "person.p_gang_county"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_tattoos"
                                  },
                                  model: {
                                    value: _vm.person.p_tattoos,
                                    callback: function($$v) {
                                      _vm.$set(_vm.person, "p_tattoos", $$v)
                                    },
                                    expression: "person.p_tattoos"
                                  }
                                },
                                [_vm._v("Tattoos?")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_tattoos === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "Tattoo Description",
                                          "label-for": "p_tattoo_description",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            type: "text",
                                            id: "p_tattoo_description"
                                          },
                                          model: {
                                            value:
                                              _vm.person.p_tattoo_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_tattoo_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_tattoo_description"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_runaway"
                                  },
                                  model: {
                                    value: _vm.person.p_runaway,
                                    callback: function($$v) {
                                      _vm.$set(_vm.person, "p_runaway", $$v)
                                    },
                                    expression: "person.p_runaway"
                                  }
                                },
                                [_vm._v("Repeat Runaway?\n            ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_runaway === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "Runaway Frequency",
                                          "label-for": "p_runaway_frequency",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            size: "lg",
                                            options: _vm.runawayOptions,
                                            id: "p_runaway_frequency"
                                          },
                                          model: {
                                            value:
                                              _vm.person.p_runaway_frequency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_runaway_frequency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_runaway_frequency"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_substance_use"
                                  },
                                  model: {
                                    value: _vm.person.p_substance_use,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_substance_use",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_substance_use"
                                  }
                                },
                                [_vm._v("Substance Use")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_substance_use === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label: "Substance Use Description ",
                                          "label-for":
                                            "p_substance_use_description",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            id: "p_substance_use_description"
                                          },
                                          model: {
                                            value:
                                              _vm.person
                                                .p_substance_use_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "p_substance_use_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "person.p_substance_use_description"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "pb-2 pl-1", attrs: { flush: "" } },
                            [
                              _c(
                                "p-check",
                                {
                                  staticClass:
                                    "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                  attrs: {
                                    large: "",
                                    color: "success",
                                    "true-value": "Yes",
                                    "false-value": "",
                                    name: "p_social_media"
                                  },
                                  model: {
                                    value: _vm.person.p_social_media,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.person,
                                        "p_social_media",
                                        $$v
                                      )
                                    },
                                    expression: "person.p_social_media"
                                  }
                                },
                                [_vm._v("Social Media Involved")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "form-fade" } }, [
                            _vm.person.p_social_media === "Yes"
                              ? _c(
                                  "div",
                                  { staticClass: "sub-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-size": "lg",
                                          "label-class": "addpersonlabel",
                                          label:
                                            "Social Media Involved Description",
                                          "label-for": "d_social_media",
                                          horizontal: false
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "lg",
                                            id: "d_social_media"
                                          },
                                          model: {
                                            value: _vm.person.d_social_media,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.person,
                                                "d_social_media",
                                                $$v
                                              )
                                            },
                                            expression: "person.d_social_media"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showVictimStatusModal
        ? _c(
            "b-modal",
            {
              attrs: {
                scrollable: "",
                title: "Victim Status",
                visible: _vm.showVictimStatusModal,
                "header-bg-variant": "success",
                "header-text-variant": "light",
                size: "md",
                centered: "",
                id: "modal",
                "ok-only": ""
              },
              on: { ok: _vm.handleVictimStatusModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-header-close",
                    fn: function() {
                      return [_c("h4", [_vm._v("X")])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2419867756
              )
            },
            [
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    this.stateName === "LA"
                      ? 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'
                      : 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  'A trafficking event is considered "suspected" when specific information regarding the individual and the surrounding circumstances creates a reasonable belief that the individual is a victim of human trafficking. The presence of one or more risk factors does not necessarily equate to a "suspected" case of trafficking.'
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            An individual is considered “at-risk” for human trafficking when the individual displays one or more risk factors of human trafficking.\n            This includes but is not limited to: system-involvement, past history of abuse, homelessness or frequent runaway behavior,\n            substance abuse disorder, among other factors. The presence of one or more risk factors for human trafficking, by itself,\n            does not equate to a confirmed or suspected case of human trafficking.\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            An individual’s victim status is considered “unknown” when the agency lacks sufficient information to classify the individual as confirmed,\n            suspected, or at-risk for human trafficking at this time. Upon gaining additional information on the individual,\n            the individual’s victim status should be updated.\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Note")]),
                _vm._v(
                  ": Most screening tools are not diagnostic tools. If a screening for human trafficking has been conducted on an individual, the results of the screening may not be sufficient alone to determine victim status."
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showServicesModal
        ? _c(
            "b-modal",
            {
              attrs: {
                scrollable: "",
                title: "Services",
                visible: _vm.showServicesModal,
                "header-bg-variant": "success",
                "header-text-variant": "light",
                size: "md",
                centered: "",
                id: "modal",
                "ok-only": ""
              },
              on: { ok: _vm.handleServicesModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-header-close",
                    fn: function() {
                      return [_c("h4", [_vm._v("X")])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2419867756
              )
            },
            [
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Addiction Recovery Services")]),
                _vm._v(
                  " – Select if victim received addiction recovery services, including rehab, detox, or an out-patient program."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Apply for Federal/State Benefits")]),
                _vm._v(
                  " - Select if the victim was provided guidance or assistance in applying for federal or state benefits (e.g. WIC, SNAP, etc.)."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Budget or Financial Literacy")]),
                _vm._v(
                  " - Select if victim received budgeting assistance and/or was provided information related to financial literacy."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Case Management")]),
                _vm._v(
                  " - Select if the victim received case management support."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Child Care")]),
                _vm._v(
                  " - Select if the victim was provided assistance in caring for their child(ren)."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Education")]),
                _vm._v(
                  " - Select if the victim was provided with educational services, such as a GED program."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Family Unification")]),
                _vm._v(
                  " - Select if the victim was provided services that assisted them in connecting with or returning to family members from whom they had been separated."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Food/Clothing/Hygiene")]),
                _vm._v(
                  " - Select if victim received direct assistance for food or groceries, clothing, shoes, and/or hygiene products."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Forensic Interview")]),
                _vm._v(
                  " - Select if victim was involved in a forensic interview."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Health")]),
                _vm._v(
                  " - Select if the victim was provided with medical care or treatment."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Housing")]),
                _vm._v(
                  " - Select if the victim was provided with shelter/housing."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Job Training")]),
                _vm._v(
                  " - Select if the victim was provided services meant to assist them in gaining employment."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Legal Services")]),
                _vm._v(
                  " - Select if the victim was provided with legal services, such as consultation or representation."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Mental Health")]),
                _vm._v(
                  " - Select if the victim was provided with mental health services (e.g. counseling, therapy, etc.)."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Mentorship")]),
                _vm._v(
                  " - Select if victim was provided mentorship or peer-to-peer support."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Multidisciplinary Team Staffing")]),
                _vm._v(
                  " - Select if a multidisciplinary team was formed in support of the victim."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Other Financial Assistance")]),
                _vm._v(
                  " - Select if victim received other financial assistance."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Parenting or Pregnancy Services")]),
                _vm._v(
                  " - Select if victim received parenting or pregnancy services, including parenting classes."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Personal Documents Assistance")]),
                _vm._v(
                  " - Select if victim received assistance in obtaining any personal documentation, such as identification, social security card, birth certificate, citizenship documents, passports, etc."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Referral to Community Services")]),
                _vm._v(
                  " - Select if the victim was referred to other service providers within the community."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Safety Planning")]),
                _vm._v(" - Select if victim was provided safety planning.")
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Translation or ESL Services")]),
                _vm._v(
                  " - Select if victim was provided translation assistance or ESL services."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Transportation")]),
                _vm._v(
                  " - Select if victim was provided transportation by the agency, including bus passes, plane tickets, ride-share trips."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Victim Advocacy")]),
                _vm._v(
                  " - Select if victim was provided victim advocacy for any criminal or civil cases. Note: this does not refer to legal representation."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Victim Compensation")]),
                _vm._v(
                  " - Select if the victim was provided with victim compensation."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Other Services")]),
                _vm._v(
                  " - Specify any other service provided that is not included in one of the previous categories."
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcf3687e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcf3687e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/PersonForm.vue
// module id = 1716
// module chunks = 0